const CDN_URL = `${import.meta.env.VITE_CDN_URL}`
const MANIFEST_URL = `${CDN_URL}/manifest.json`

const getFilePath = (manifest, key) => `${CDN_URL}/${manifest[key]?.file}`

const fetchManifest = async () => {
  const response = await fetch(`${MANIFEST_URL}?v=${new Date().getTime()}`)
  return response.json()
}

const manifest = await fetchManifest()

export async function registerActionCardComponent(dataProvider) {
  const mainJsPath = getFilePath(manifest, 'src/main.tsx')

  const { registerCustomComponent } = await import(mainJsPath)

  registerCustomComponent(dataProvider)
}

export async function getActionCardModule() {
  const mainJsPath = getFilePath(manifest, 'src/main.tsx')

  return await import(mainJsPath)
}
